import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CustomButton from '../../../UI/CustomButton';
import '../add.scss';

const useStyles = makeStyles(() => ({
  accordingRoot: {
    boxShadow: 'none !important',
    border: 'none !important',
    padding: '0 !important',

    '& .Mui-expanded': {
      margin: '0.35rem 0 !important',
    },
  },
  accordionDetailsRoot: {
    padding: '0 1rem',
  },
}));

const UserBulkAccording = ({ file, setFile, fileLoading, onSubmitFile }) => {
  const styles = useStyles();

  return (
    <Accordion classes={{ root: styles.accordingRoot }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon color='action' />}
        aria-controls='panel1-content'
        id='panel1-header'
        sx={{ padding: '0' }}
      >
        <Box className='spaceBetween' mt={1}>
          <Box className='flexCenter' gap={1} onClick={(e) => e.stopPropagation()}>
            <label htmlFor='user'>
              <Box className='fileContainer'>
                {file ? <ModeEditRoundedIcon /> : <AddRoundedIcon />}
                <Typography>{file ? 'تغییر فایل اکسل' : 'انتخاب فایل اکسل'}</Typography>
              </Box>
              <input
                type='file'
                id='user'
                style={{ display: 'none' }}
                accept='.xlsx, .xls, .csv'
                onChange={(e) => setFile(e.target.files[0])}
              />
            </label>

            {file && <Typography>{file.name}</Typography>}

            <CustomButton variant='outlined' disabled={fileLoading || !file} onClick={onSubmitFile}>
              {fileLoading ? (
                <Box className='flexCenter'>
                  <Typography color='text.main' fontSize='small' m={1}>
                    در حال ارسال
                  </Typography>
                  <CircularProgress size={18} color='primary' />
                </Box>
              ) : (
                <Typography noWrap color='primary' sx={{ opacity: !file ? '0.6' : '1' }}>
                  ارسال فایل
                </Typography>
              )}
            </CustomButton>
          </Box>

          <Typography color='text.main' mb={1}>
            راهنمای فایل اکسل
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails classes={{ root: styles.accordionDetailsRoot }}>
        <Box className='accordingList'>
          <ul>
            <li>حجم فایل اکسل شما باید کمتر از ۲ مگابایت باشد</li>
            <li>شماره تلفن کاربران شما حتماً باید با ۹۸ شروع شود.</li>
            <li>فایل اکسل شما شامل ۴ فیلد به ترتیب:</li>
            <li>name, lastName, mobileNumber, email</li>
            <li>
              که به ترتیب از چپ به راست شامل: نام کاربر، نام خانوادگی کاربر، شماره تلفن کاربر و
              ایمیل کاربر ✉️ است
            </li>
            <li>فیلد ایمیل میتواند به صورت اختیاری خالی باشد</li>
            <li>فایل اکسل شما باید مشابه فایل سمپلی که در اختیار شما قرار داده شده است، باشد.</li>
            <li>
              در صورتی که کاربری قبلاً اضافه شده باشد یا عضو سازمان دیگری باشد یا یکی از اطلاعات
              نادرست وارد شده باشد، خطا دریافت خواهید کرد.
            </li>
            <li>گذرواژه همه کاربران بعد از اضافه شدن، به صورت پیامکی برایشان ارسال خواهد شد</li>
            <li>
              کاربر سازمان در صورت فراموشی گذرواژه ، میتواند از قسمت فراموشی رمز عبور، گذرواژه جدیدی
              را تعیین نماید
            </li>
            <li>
              اضافه کردن کاربران ممکن است کمی زمانبر باشد ⏳؛ لطفاً تا دریافت پیام پایان کار صبر
              کنید.
            </li>
          </ul>

          <CustomButton
            variant='outlined'
            startIcon={<FileDownloadRoundedIcon color='primary' />}
            onClick={() =>
              window.open(
                window.location.host === 'org.arsis.app'
                  ? 'https://arsis.app/docs/sample_excel_arsis.xlsx'
                  : 'http://185.53.142.99/docs/sample_excel_arsis.xlsx',
                '_blank',
              )
            }
          >
            دانلود فایل نمونه اکسل
          </CustomButton>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default UserBulkAccording;
